























































































import { computed, defineComponent } from '@vue/composition-api'
import KaiButton from '../common/KaiButton.vue'
import KaiCheckbox from '../common/KaiCheckbox.vue'
import TagsCategory from '../tags/TagsCategory.vue'
import AnalysisDetails from '../AnalysisDetails.vue'
import { clearTextSelection } from '../../composables/clearTextSelection'
import { useActions } from '../../store/useActions'
import { useGetters } from '../../store/useGetters'
import { getSelectionIndices } from '../../utils/selection'
import { TagCategory, UITopic } from '../../types/tag'

export default defineComponent({
  name: 'AllTagsSection',
  components: { AnalysisDetails, KaiButton, TagsCategory, KaiCheckbox },
  setup(props, { emit }) {
    const getters = useGetters({
      openTag: 'tagsPicker/openTag',
      openTagIndex: 'tagsPicker/openTagIndex',
      active: 'tagsPicker/isActive',
      analysisActive: 'tagsPicker/analysisActive',
      activeTab: 'tagsPicker/activeTab',
      analysisTags: 'transcriptTags/analysisCategories',
      topics: 'tagsPicker/topicsCategories',
      selectedTopics: 'tagsPicker/selectedTopics',
      range: 'selection/range',
      selectedPart: 'selection/part',
      transcript: 'conversation/transcript'
    })

    const actions = useActions({
      addTagToText: 'transcriptTags/addTagToText',
      editTag: 'transcriptTags/editTag',
      clearSelection: 'selection/clearSelection',
      toggleSelectionPopup: 'selection/togglePopup',
      toggleActive: 'tagsPicker/toggle',
      showAnalysis: 'tagsPicker/showAnalysis',
      activateAnalysisTags: 'transcriptTags/showAnalysis',
      activateTopicTags: 'transcriptTags/showTopics',
      showCustomTags: 'tagsPicker/showCustomTags',
      toggleTag: 'tagsPicker/toggleTag',
      // toggleAnalysisTag: 'tagsPicker/toggleAnalysisTag',
      toggleAnalysisTag: 'transcriptTags/toggleAnalysisTag',
      toggleTagsCategory: 'tagsPicker/toggleTagsCategory',
      closeTagEdit: 'tagsPicker/closeTagEdit'
    })

    const addTag = async () => {
      if (getters.openTag.value && getters.openTagIndex.value) {
        const [tagsToEdit, tagsToDelete] = await actions.editTag({
          wordIndex: getters.openTagIndex.value,
          tag: getters.openTag.value,
          topics: getters.selectedTopics.value,
          speakerName: getters.selectedPart.value.speaker
        })

        emit('edit-tag', { tagsToEdit, tagsToDelete })
      } else {
        const indices = getSelectionIndices(getters.range.value)

        if (indices.length !== 2) {
          return
        }

        const [tagsToAdd, tagsToDelete] = await actions.addTagToText({
          startIndex: indices[0],
          endIndex: indices[1],
          topics: getters.selectedTopics.value,
          speakerName: getters.selectedPart.value.speaker
        })

        emit('add-tags', { tagsToAdd, tagsToDelete })
      }

      actions.closeTagEdit()
      actions.toggleActive()
      actions.clearSelection(true)
      clearTextSelection()
    }

    function toggleAnalysisTag(categoryId: number, tagId: number) {
      // TODO: refactor
      actions.toggleAnalysisTag(tagId)
      // actions.toggleAnalysisTag({ categoryId, tagId })
    }

    function toggleTagsCategory(categoryId: number) {
      actions.toggleTagsCategory(categoryId)
    }

    function toggleTag(topicId: number) {
      actions.toggleTag(topicId)
    }

    const defaultTagsActive = computed(() => !getters.analysisActive.value)

    function getSubtopicsChecked(id: number): number {
      const topicById = getters.topics.value.find(
        (t: TagCategory) => t.id === id
      )
      return topicById.topics.map((t: UITopic) => t.isActive).filter(Boolean)
        .length
    }

    function showAnalysis() {
      actions.showAnalysis()
      actions.activateAnalysisTags()
    }

    function showCustomTags() {
      actions.showCustomTags()
      actions.activateTopicTags()
    }
    const filteredTopics = computed(() =>
      getters.topics.value
        .map(category => ({
          ...category,
          topics: category.topics.filter(topic => !!topic.title)
        }))
        .filter(category => category.topics.length > 0)
    )

    return {
      defaultTagsActive,
      active: getters.active,
      analysisActive: getters.analysisActive,
      topics: filteredTopics,
      analysisTags: getters.analysisTags,
      activeTab: getters.activeTab,
      showAnalysis,
      showCustomTags,
      getSubtopicsChecked,
      toggleTagsCategory,
      toggleAnalysisTag,
      toggleTag,
      addTag
    }
  }
})
